import classNames from "classnames/bind";
import { ProductsCarousel } from "app/pages/.shared/ProductsCarousel";
import ProductCard from "app/pages/.shared/ProductCard/ProductCard";
import type { MembershipOffersColumns, MembershipProduct } from "../types";
import styles from "./MembershipBlock.module.scss";

const cx = classNames.bind(styles);

const GRID_PHOTO_SIZES: Record<MembershipOffersColumns, string> = {
	2: "496px",
	3: "325px",
};

type MembershipOffersProps = {
	products: MembershipProduct[];
	isMobile: boolean;
	columns: MembershipOffersColumns;
	/** How far the mobile carousel overflows the block. */
	bleed?: number | string;
	/** Id of the block heading, which names the carousel. */
	labelledBy?: string;
};

/** Member offers: a carousel on mobile, a list laid out as a grid on desktop. */
export const MembershipOffers = ({
	products,
	isMobile,
	columns,
	bleed,
	labelledBy,
}: MembershipOffersProps) => {
	if (isMobile) {
		return (
			<ProductsCarousel
				products={products}
				variant="ghost"
				showCta={false}
				bleed={bleed}
				aria-labelledby={labelledBy}
			/>
		);
	}

	return (
		<ul className={cx("membership-block__offers")} data-columns={columns}>
			{products.map((product, index) => (
				<li key={product.id} className={cx("membership-block__offer")}>
					<ProductCard
						product={product}
						position={index}
						variant="ghost"
						showCta={false}
						photoSizes={GRID_PHOTO_SIZES[columns]}
					/>
				</li>
			))}
		</ul>
	);
};
